import { useIntl } from '@/intl'
import { useFilters, useResults } from '@/scopes/search/search/domain/hooks'
import { Filters } from '@/scopes/search/search/pages/SearchPage/components/Filters'
import { mqMin, space, tok } from '@sunwebgroup/ui-components'
import { Button, Icon, Sheet } from '@sunwebgroup/ui-components/uds'
import { IndeterminateProgressCircle } from '@sunwebgroup/ui-components/uds/index'
import * as React from 'react'
import { styled } from 'styled-components'

const FiltersButton = styled(Button)`
  display: flex;
  position: fixed;
  bottom: ${space('primitives_space_24')};
  z-index: 1; // To ensure the filter button is always on top of the accommodation slider
  width: calc(100% - (2 * ${space('primitives_space_16')}));
  box-shadow: ${tok('primitives_box_shadows_level_3')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    width: calc(100% - (2 * ${space('primitives_space_32')}));
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    display: none;
  }
`

export function FiltersModal() {
  const intl = useIntl()
  const { isFetching } = useResults()
  const { resetOptionalFilters } = useFilters()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Sheet.Root open={open} onOpenChange={setOpen}>
        <Sheet.Trigger>
          <FiltersButton $type="secondary" $fullWidth>
            <Icon glyph="Sliders" />
            {intl.formatMessage({ id: 'search_open_filters' })}
          </FiltersButton>
        </Sheet.Trigger>
        <Sheet.Body side="bottom">
          <Sheet.Header closeLabel={intl.formatMessage({ id: 'close' })} titleLabel={intl.formatMessage({ id: 'search_open_filters' })}>
            <Button
              $type="transparentPrimary"
              $size="S"
              onClick={(event) => {
                resetOptionalFilters()
                setOpen(false)
                event.preventDefault()
              }}
            >
              {intl.formatMessage({ id: 'search_reset_filters_sheet_header' })}
            </Button>
          </Sheet.Header>
          <Sheet.Content>
            <Filters />
          </Sheet.Content>
          <Sheet.Footer isFixed>
            <Button $type="primary" $fullWidth disabled={isFetching} onClick={() => { setOpen(false) }}>
              {isFetching && <IndeterminateProgressCircle />}
              {intl.formatMessage({ id: 'search_apply_filters' })}
            </Button>
          </Sheet.Footer>
        </Sheet.Body>
      </Sheet.Root>
    </>
  )
}
